import { useTopLevelUser } from "@bokio/contexts/TopLevelUserContext/useTopLevelUser";

import type { LoginsControls } from "@bokio/contexts/TopLevelUserContext/TopLevelUserContext";

export const useLoginsControls = (): LoginsControls => {
	const { loginsControls } = useTopLevelUser();
	return loginsControls;
};
